<nav class="absolute w-full bg-transparent">
  <div class="flex items-center justify-between px-8 py-5 lg:px-10">
    <!-- Logo -->
    <button
      (click)="toggle()"
      class="w-fit cursor-pointer invert-0 dark:invert-100">
      <img src="/img/logo.svg" width="125" alt="Logo" />
    </button>

    <!-- Drawer Sidebar -->
    <div class="flex">
      <p-drawer [(visible)]="visible" position="left">
        <!-- Header -->
        <ng-template #header>
          <span class="mx-3 inline-flex items-center gap-2">
            <img
              src="/img/logo.svg"
              width="125"
              class="invert-0 dark:invert-100"
              alt="Logo" />
          </span>
        </ng-template>

        <!-- Body -->
        <div
          class="flex h-full flex-col gap-3 overflow-x-hidden overflow-y-auto pt-5">
          @for (route of routes(); track $index) {
            @if (route.isDropdown) {
              <app-sidebar-dropdown
                [route]="route"
                (itemClicked)="visible.set(false)" />
            } @else {
              <app-tabs
                [route]="route"
                [alignStart]="true"
                (click)="visible.set(false)" />
            }
          }
        </div>

        <!-- Footer -->
        <ng-template #footer>
          <div class="flex h-full w-full flex-col justify-between">
            <div></div>
            <button
              (click)="signOut()"
              class="mt-2 flex cursor-pointer items-center gap-2 rounded-lg px-4 py-1 font-normal text-gray-700 transition-transform duration-300 ease-in-out hover:text-red-500 dark:text-gray-400">
              <ng-icon name="matLogOut" size="20px" />
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </ng-template>
      </p-drawer>
    </div>

    <!-- Options -->
    <div class="flex items-center justify-center gap-4">
      <!-- Mismas rutas del sidebar: ya filtradas por los permisos del rol -->
      <app-global-search [routes]="routes()" />
      <p-menu #menu [model]="menuItems()" [popup]="true">
        <ng-template #item let-item>
          <!-- p-menu ya ejecuta item.command en el click del contenedor -->
          <div class="flex cursor-pointer items-center gap-1.5 p-2 text-sm">
            <ng-icon [name]="item.icon" size="20" strokeWidth="1" />
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
      </p-menu>
      <button
        (click)="menu.toggle($event)"
        class="cursor-pointer text-gray-400 hover:text-gray-500">
        <ng-icon name="matSettingsOutline" size="20" strokeWidth="1" />
      </button>
    </div>
  </div>
</nav>
